module.exports = __webpack_public_path__ + "static/media/DiscountColor.6d03d988.svg";